/*eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Row, Card, Col } from 'react-bootstrap';
import ProgressBar from '../../../progressbar/progressbar';
import { findPercentage } from '../../../../../Member/utils/common';
import FilterModal from '../../../common/filter-modal/FilterModal';
import { CoverageHistory } from '../../coverage/coverage-details/coverageHistory';
import useDate from '../../../../utils/useDate';
import Feature from '../../../../../services/feature';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

export const AccountDetailsPanel = ({
  AccountName,
  AmountSpent,
  AnnualContribution,
  Balance,
  membersCovered,
  coverageData,
  planDetails,
  isAPIFailed,
  isNotFound,
  activeMemType,
  activeOID,
  activeAccountName,
  ...otherProps
}) => {
  const [isOpenCoveragePopup, setIsOpenCoveragePopup] = useState(false);
  const showCancel = false;
  const titleLabel = 'Coverage History';
  const showApply = true;
  const showApplyLabel = 'CLOSE';
  const activeCoverageType = 'Flex';
  const lastIndex = coverageData?.length;
  const applyFilterHandler = () => {
    setIsOpenCoveragePopup(false);
  };
  const memberCoverageDetails = planDetails?.MemberCoverage;
  const data = memberCoverageDetails?.find(
    (plans) => plans.Product === activeCoverageType,
  );
  const { formatDate } = useDate();
  return (
    <Card className="w-100 mt-4 mt-sm-0">
      <Card.Body>
        <Row className="align-items-center">
          <Col md={4} lg={4} xs={12}>
            <div className="right-border-account-details">
              <div className="first-block">
                <p className="acc-account-name">{AccountName}</p>
                <div className="before-circle-light text-center">
                  Available Balance
                </div>
                <div className="avail-bal">{formatter.format(Balance)}</div>
                <div className="mx-auto spendings-progress-bar">
                  <ProgressBar
                    completed={findPercentage(AmountSpent, AnnualContribution)}
                  />
                </div>
                <Row>
                  <Col>
                    <div className="before-circle-light-teritary">
                      Spent Amount: <b>{formatter.format(AmountSpent)}</b> of
                      &nbsp;
                      <b>{formatter.format(AnnualContribution)}</b>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col
            md={8}
            lg={8}
            xs={12}
            className="mt-4 mt-sm-0 second-block account-details-section-labels"
          >
            <Row>
              <Col md={6} lg={6} xs={12}>
                <p>
                  <label>Benefit Plan</label> {data?.BenefitPlan}
                </p>
                <p>
                  <label>Coverage Status</label> {planDetails?.Status}
                </p>
                <p>
                  <label>Coverage Period</label>{' '}
                  {formatDate(planDetails?.EffectiveDate)} -{' '}
                  {formatDate(planDetails?.TerminationDate) || 'Current'}
                </p>
                <p>
                  <label>Coverage Effective From</label>{' '}
                  {formatDate(coverageData[lastIndex - 1]?.EffectiveDate)}
                </p>
              </Col>

              <Col md={6} lg={6} xs={12}>
                <p>
                  <label>Coverage Level</label> Member Only
                </p>
                {activeAccountName?.data?.EmplrPayPeriod && (
                  <p>
                    <label>Employer Contribution</label>
                    <b>
                      {' '}
                      {formatter.format(
                        activeAccountName?.data?.EmplrContrAmount,
                      )}{' '}
                      {activeAccountName?.data?.EmplrPayPeriod}
                    </b>
                  </p>
                )}
                {activeAccountName?.data?.EmplePayPeriod && (
                  <p>
                    <label>My Contribution</label>
                    <b>
                      {' '}
                      {formatter.format(
                        activeAccountName?.data?.EmpleContrAmount,
                      )}{' '}
                      {activeAccountName?.data?.EmplePayPeriod}
                    </b>
                  </p>
                )}

                <p>
                  <label
                    className="view-coverage-summary"
                    onClick={() => {
                      setIsOpenCoveragePopup(true);
                    }}
                  >
                    View Coverage History
                  </label>
                </p>

                <FilterModal
                  isVisible={isOpenCoveragePopup}
                  onHide={() => {
                    setIsOpenCoveragePopup(false);
                  }}
                  applyFilterHandler={applyFilterHandler}
                  showCancel={showCancel}
                  titleLabel={titleLabel}
                  showApply={showApply}
                  showApplyLabel={showApplyLabel}
                >
                  {coverageData && (
                    <CoverageHistory
                      {...otherProps}
                      activeCoverageType={activeCoverageType}
                      activeMemType={activeMemType}
                      activeOID={activeOID}
                      membersCovered={membersCovered}
                    />
                  )}
                </FilterModal>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
